import Vue from 'vue';

const state = {
  user: {},
};

const actions = {};

const mutations = {};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
